import { inject, Injectable } from '@angular/core';
import { SizedSKUMapEntry } from 'src/app/interfaces/sized-sku-map-entry';
import { SkuMapProviderService } from 'src/app/providers/sku-map/sku-map.provider.service';

@Injectable({
  providedIn: 'root'
})
export class SkuMapService {
  private skuMapProviderService = inject(SkuMapProviderService);

  get(haloSKU: string) {
    return this.skuMapProviderService.get(haloSKU);
  }

  getReverse(ringBuilderSKU: string, size?: number) {
    return this.skuMapProviderService.getReverse(ringBuilderSKU, size);
  }

  async getWithShortCode(shortCode: number): Promise<SizedSKUMapEntry | null> {
    return this.skuMapProviderService.getWithShortCode(shortCode);
  }
}
